import { requestDashboardHelp } from '../../utils/dashboardHelp';

export function formatPaymentStatusTime(value) {
  const date = new Date(value);
  return value && Number.isFinite(date.getTime()) ? date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : null;
}

export function paymentDeadlineLabel(deadline) {
  return typeof deadline === 'number' && Number.isFinite(deadline)
    ? `Complete by ${new Date(deadline * 1000).toLocaleDateString(undefined, { dateStyle: 'medium' })}.` : null;
}

export function openPaymentSupport() {
  if (requestDashboardHelp()) return;
  if (window.Productlane?.open) window.Productlane.open();
  else window.location.href = 'mailto:support@charitystack.com';
}
